import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';
import QueryParams from 'utils/queryParams';

import { TASKS_API_URL, QUERY_KEYS, DEFAULT_PAGE_LIMIT } from '../constants';

import type { IDashboardFilters, IDashboardTasksResponse } from '../types';

export const fetchDashboardTasks = async (
  filters: IDashboardFilters,
): Promise<IDashboardTasksResponse> => {
  const { limit, offset, ...rest } = filters;
  const url = QueryParams.stringifyUrl(TASKS_API_URL, {
    ...rest,
    limit: limit ?? DEFAULT_PAGE_LIMIT,
    offset: offset ?? 0,
  });
  const { error, data } = await dataService.getList<IDashboardTasksResponse>(
    url,
  );
  if (error) throw new Error(error);
  if (!data) throw new Error('No data returned from API');
  return data;
};

export function useDashboardTasks(filters: IDashboardFilters) {
  return useQuery({
    queryKey: [QUERY_KEYS.dashboardTasks, filters],
    queryFn: () => fetchDashboardTasks(filters),
    refetchInterval: 30000,
    staleTime: 15000,
    refetchIntervalInBackground: false,
    keepPreviousData: true,
  });
}
